// extracted by mini-css-extract-plugin
export var isPrintedCell = "_xc-1";
export var printerIcon = "_xc-0";